import EntityBase from '@/data/EntityBase';
import Integration from '@/integrations/modules/go/store/models/integration';
import GustoCheck from '@/integrations/modules/gusto/models/GustoCheck';
import { GustoConfiguration } from '@/integrations/modules/gusto/models/GustoConfiguration';

export default class GustoState extends EntityBase({
  configuration: new GustoConfiguration(),
  check: new GustoCheck(),
  integration: new Integration(),
  integrationLoaded: false,
}) {}
